import { tTypeAttachment } from '../../MessageBubble.type.ts';

export default function AudioContent(props: tTypeAttachment) {
  return (
    <div className="flex justify-center">
      <audio src={props.attachment.url ?? ''} controls />
    </div>
  );
}
